import React, { ReactNode } from "react";
import { Card, Tag, Empty, Spin, Typography } from "antd";
import { InboxOutlined } from "@ant-design/icons";
const { Text } = Typography;
// ── InlineLoading ─────────────────────────────────────────────
// Centered loading state with optional message.
// Use inside card bodies while data is loading.
//
// Usage:
//   {loading ? <InlineLoading /> : <Table ... />}

interface InlineLoadingProps {
  message?: string;
  minHeight?: number;
}

const InlineLoading: React.FC<InlineLoadingProps> = ({
  message = "Loading…",
  minHeight = 200,
}) => (
  <div style={{
    minHeight,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: 12,
  }}>
    <Spin size="default" />
    <Text type="secondary" style={{ fontSize: 12 }}>{message}</Text>
  </div>
);

export default InlineLoading;